module.exports = __webpack_public_path__ + "media/images/home/ic_edit-49d67a2feef4f460a3cd079966e3d3db.svg";